import { CartContainer } from "./style";
import { useSelector } from "react-redux";

export function CardProductCheckout() {
  const data  = useSelector((state) => state.cartSlice.data);    
  
   const totalCart = data.reduce((acc, item) => {
      return acc + (item.price * item.quantity);
   }, 0);

  return (
     <CartContainer>
      <p>Resumo da compra</p>
      {data.map(({id, name, price, img, productCode }) => (        
         <div className="cartContent" key={id}>
            <img src={img} alt="" />
            <h3>{name}</h3>
            <p>{productCode}</p>               
            <span>{price.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'})}</span>
         </div>
      ))}
      <p className="subtotal">Total: {totalCart.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'})}</p>
     </CartContainer>
  );
}
